import { ThemeOverride } from "@chakra-ui/react";

type SemanticTokens = Required<ThemeOverride>["semanticTokens"];
const semanticTokens: SemanticTokens = {
  colors: {
    text: {
      default: "#16161D",
      _dark: "#ade3b8"
    },
    heroGradientStart: {
      default: "#7928CA",
      _dark: "#e3a7f9"
    },
    heroGradientEnd: {
      default: "#FF0080",
      _dark: "#fbec8f"
    },
    // Custom colors
    "bg-dark": "blue.800",
    "bg-subtle-dark": "gray.700",
    "bg-light": "gray.50",
    "bg-subtle-light": "white",
    "text-dark": "white",
    "text-subtle-dark": "gray.400",
    "text-light": "blue.900",
    "text-subtle-light": "gray.500",
    "border-light": "gray.200",
    "border-dark": "whiteAlpha.300",
    "misc-hover-dark": "blue.900",
    "misc-hover-light": "blue.50",
    "misc-hover": {
      _light: "misc-hover-light",
      _dark: "misc-hover-dark"
    },
    "misc-highlight": { _light: "blue.500", _dark: "blue.300" },
    "red-bright": "red.500",
    "red-pale": "red.200",
    "red-adaptive": { _light: "red-bright", _dark: "red-pale" },
    "nav-bg": { _light: "purple.800", _dark: "purple.800" },
    // Standard chakra variables
    "chakra-body-text": { _light: "text-light", _dark: "text-dark" },
    "chakra-body-bg": { _light: "bg-light", _dark: "bg-dark" },
    "chakra-border-color": {
      _light: "border-light",
      _dark: "border-dark"
    },
    "chakra-inverse-text": { _light: "text-dark", _dark: "text-light" },
    "chakra-subtle-bg": {
      _light: "bg-subtle-light",
      _dark: "bg-subtle-dark"
    },
    "chakra-subtle-text": {
      _light: "text-subtle-light",
      _dark: "text-subtle-dark"
    },
    "chakra-placeholder-color": {
      _light: "chakra-subtle-text",
      _dark: "chakra-subtle-text"
    }
  },
  radii: {
    button: "12px"
  }
};

export default semanticTokens;
